import React, { useState } from 'react';
import './Galery.css';
import { Helmet } from "react-helmet-async";
import { useTranslation } from 'react-i18next';

// sam regisotn
import registon1 from '../photos/registon.webp';
import registon2 from '../photos/registon_night.webp';
import registon3 from '../photos/registon_day.webp';
import registon4 from '../photos/uzb_sam_reg1.webp';

//  bibihonim
import bibixonim1 from '../photos/bibihonim1.webp';
import bibixonim2 from '../photos/bibihonim2.webp';
import bibixonim3 from '../photos/uzb_sam_bibi1.webp';
import bibixonim4 from '../photos/uzb_sam_bibi2.webp';
import bibixonim5 from '../photos/uzb_sam_bibi3.webp';
import bibixonim6 from '../photos/uzb_sam_bibi4.webp';
import bibixonim7 from '../photos/uzb_sam_bibi5.webp';
import bibixonim8 from '../photos/uzb_sam_bibi6.webp';


// sam
import sam1 from '../photos/samarqand_city1.webp';
import sam2 from '../photos/samarqand1.webp';
import sam3 from '../photos/samarqand_paper.webp';
import sam4 from '../photos/samarqand_city2.webp';

// guremir
import guremir1 from '../photos/uzb_sam_guremir1.webp';
// sam shoxizinda
import shoxizinda1 from '../photos/shoxizinda1.webp';
import shoxizinda2 from '../photos/shoxizinda2.webp';
// bukhara
import buxoro1 from '../photos/buxoro1.webp';
import buxoro2 from '../photos/buxoro2.webp';
import buxoro3 from '../photos/buxoro3.webp';
// shaxrisabz
import shaxrisabz1 from '../photos/shahrisabz1.webp';
import shaxrisabz2 from '../photos/shahrisabz2.webp';
// toshkent
import tosh1 from '../photos/toshkent1.webp';
import tosh2 from '../photos/toshkent2.webp';
import tosh3 from '../photos/toshkent3.webp';
import tosh4 from '../photos/toshkent4.webp';
// foods
import stol1 from '../photos/food1.webp';
import manti from '../photos/food2.webp';
import norin from '../photos/food3.webp';
import plov from '../photos/food4.webp';
import samusa from '../photos/food5.webp';
import stol2 from '../photos/food6.webp';
// xiva
import xiva1 from '../photos/xiva1.webp';
import xiva2 from '../photos/xiva2.webp';
// ulugbek observatoriyasi
import observatoria from '../photos/ulugbek_observatoriyasi.webp';
// imom buxoriy
import buxoriy1 from '../photos/buxoriy1.webp';
import buxoriy2 from '../photos/buxoriy2.webp';
import buxoriy3 from '../photos/buxoriy3.webp';
import buxoriy4 from '../photos/buxoriy4.webp';
import buxoriy5 from '../photos/buxoriy5.webp';
import buxoriy6 from '../photos/buxoriy6.webp';
import buxoriy7 from '../photos/buxoriy7.webp';
// fargona
import fargona from '../photos/fargona.webp';
// margilan
import margilan from '../photos/margilan.webp';
// namangan
import namangan from '../photos/namangan.webp';
// navoiy
import navoiy from '../photos/navoiy.webp';
// andijan
import andijan from '../photos/andijon.webp';
// nukus
import nukus from '../photos/nukus.webp';
// qoqon
import qoqon from '../photos/qoqon.webp';
// termiz
import termiz from '../photos/termiz.webp';

// videos
import imombuhoriy1 from '../videos/imombuhoriy_vd1.mp4';
import imombuhoriy2 from '../videos/imombuhoriy2.mp4';
import regiton_vd from '../videos/registon_vd.mp4';
import islom_sivilizatsiyasi from '../videos/islom_sivilizatsiyasi.mp4';  
import guremir from '../videos/guremir.mp4';  
import minoraikalon from '../videos/minorai-kalon.mp4';
import samarkandvd from '../videos/sam.mp4';

const images = [
    { id: 1, name: 'Registan Square', image: registon1, gallery: [registon1, registon2, registon3, registon4] },
    { id: 2, name: 'Bibi-Khanym Mosque', image: bibixonim1, gallery: [bibixonim1, bibixonim2, bibixonim3, bibixonim4, bibixonim5, bibixonim6, bibixonim7, bibixonim8] },
    { id: 3, name: 'Samarkand', image: sam1, gallery: [sam1, sam2, sam3, sam4] },
    { id: 4, name: 'Bukhara', image: buxoro1, gallery: [buxoro1, buxoro2, buxoro3] },
    { id: 5, name: 'Shahrisabz', image: shaxrisabz1, gallery: [shaxrisabz1, shaxrisabz2] },
    { id: 6, name: 'Shah-i-Zinda Necropolis', image: shoxizinda1, gallery: [shoxizinda1, shoxizinda2] },
    { id: 7, name: 'Tashkent', image: tosh1, gallery: [tosh1, tosh2, tosh3, tosh4] },
    { id: 8, name: 'Khiva ', image: xiva1, gallery: [xiva1, xiva2] },
    { id: 9, name: 'Ulugh Beg Observatory', image: observatoria, gallery: [observatoria] },
    { id: 10, name: 'Imam al-Bukhari Complex', image: buxoriy1, gallery: [buxoriy2, buxoriy3, buxoriy4, buxoriy5, buxoriy6, buxoriy7] },
    { id: 11, name: 'Uzbek National Cuisine', image: stol1, gallery: [stol1, stol2, manti, norin, plov, samusa] },
    { id: 12, name: 'Fergana', image: fargona, gallery: [fargona] },
    { id: 13, name: 'Margilan Silk Center', image: margilan, gallery: [margilan] },
    { id: 14, name: 'Namangan', image: namangan, gallery: [namangan] },
    { id: 15, name: 'Navoi', image: navoiy, gallery: [navoiy] },
    { id: 16, name: 'Andijan', image: andijan, gallery: [andijan] },
    { id: 17, name: 'Nukus', image: nukus, gallery: [nukus] },
    { id: 18, name: 'Kokand', image: qoqon, gallery: [qoqon] },
    { id: 19, name: 'Termez', image: termiz, gallery: [termiz] },
];

const videos = [
    {
        id: 1,
        name: 'Imom al-Bukhoriy complex ',
        thumbnail: buxoriy1,
        videoUrl: imombuhoriy1,
    },
    {
        id: 2,
        name: 'Imom al-Bukhoriy complex ',
        thumbnail: buxoriy2,
        videoUrl: imombuhoriy2,
    },
    {
        id: 3,
        name: 'Registon Square',
        thumbnail: registon1,
        videoUrl: regiton_vd,
    },
    {
        id: 4,
        name: 'Islamic Civilization in Uzbekistan Museum',
        thumbnail: tosh1,
        videoUrl: islom_sivilizatsiyasi,
    },
    {
        id: 5,
        name: 'Guremir Mosoleum',
        thumbnail: guremir1,
        videoUrl: guremir,
    },
    {
        id: 6,
        name: 'Minaret of Kalon',
        thumbnail: buxoro3,
        videoUrl: minoraikalon,
    },
    {
        id: 7,
        name: 'Samarkand',
        thumbnail: registon2,
        videoUrl: samarkandvd,
    },
];

const Gallery = () => {
    const [activeTab, setActiveTab] = useState('photo');
    const [selectedGallery, setSelectedGallery] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeVideo, setActiveVideo] = useState(null);
    const { t } = useTranslation();

    const openModal = (gallery) => {
        setSelectedGallery(gallery);
        setCurrentIndex(0);
    };

    const closeModal = () => setSelectedGallery(null);

    const changeImage = (dir) => {
        let newIndex = currentIndex + dir;
        if (newIndex < 0) newIndex = selectedGallery.length - 1;
        if (newIndex >= selectedGallery.length) newIndex = 0;
        setCurrentIndex(newIndex);
    };

    const openVideo = (video) => setActiveVideo(video);
    const closeVideo = () => setActiveVideo(null);

    return (
        <section className="gallery-section">
            <Helmet>
                <title>Adam Voyage — Travel Gallery</title>
                <meta
                    name="description"
                    content="Browse our gallery of stunning Uzbekistan destinations and unforgettable travel moments."
                />
            </Helmet>

            <h2 className="gallery-title">{t("gallery.title")}</h2>

            {/* ===== TAB BUTTONS ===== */}
            <div className="gallery-tabs">
                <button
                    className={`gallery-tab-btn ${activeTab === 'photo' ? 'active' : ''}`}
                    onClick={() => setActiveTab('photo')}
                >
                    📷 Foto
                </button>
                <button
                    className={`gallery-tab-btn ${activeTab === 'video' ? 'active' : ''}`}
                    onClick={() => setActiveTab('video')}
                >
                    🎬 Video
                </button>
            </div>

            {/* ===== PHOTO TAB ===== */}
            {activeTab === 'photo' && (
                <div className="gallery-grid">
                    {images.map((place) => (
                        <div
                            className="gallery-card"
                            key={place.id}
                            onClick={() => openModal(place.gallery)}
                        >
                            <img src={place.image} alt={place.name} />
                            <div className="gallery-overlay">
                                <h3>{place.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* ===== VIDEO TAB ===== */}
            {activeTab === 'video' && (
                <div className="gallery-grid">
                    {videos.map((video) => (
                        <div
                            className="gallery-card video-card"
                            key={video.id}
                            onClick={() => openVideo(video)}
                        >
                            {video.thumbnail ? (
                                <img src={video.thumbnail} alt={video.name} />
                            ) : (
                                <div className="video-placeholder">
                                    <span className="video-play-icon">▶</span>
                                </div>
                            )}
                            <div className="gallery-overlay">
                                <h3>{video.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* ===== PHOTO MODAL ===== */}
            {selectedGallery && (
                <div className="modal" onClick={closeModal}>
                    <span className="modal-close">&times;</span>

                    <button
                        className="prev"
                        onClick={(e) => {
                            e.stopPropagation();
                            changeImage(-1);
                        }}
                    >
                        ❮
                    </button>

                    <img
                        src={selectedGallery[currentIndex]}
                        alt="Selected"
                        className="modal-content"
                    />

                    <button
                        className="next"
                        onClick={(e) => {
                            e.stopPropagation();
                            changeImage(1);
                        }}
                    >
                        ❯
                    </button>
                </div>
            )}

            {/* ===== VIDEO MODAL ===== */}
            {activeVideo && (
                <div className="modal video-modal" onClick={closeVideo}>
                    <span className="modal-close">&times;</span>
                    <div
                        className="video-modal-inner"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <video
                            src={activeVideo.videoUrl}
                            controls
                            autoPlay
                            className="video-iframe"
                        />
                    </div>
                </div>
            )}
        </section>
    );
};

export default Gallery;